<template>
  <div id="app">
    <div class="container">
        <TestimonyForm />
    </div>
  </div>
</template>

<script>
import TestimonyForm from "./components/TestimonyForm.vue";

export default {
  name: "App",
  components: {
    TestimonyForm
  }
};
</script>

<style scoped>

</style>
